<template>
  <div class="questionnaire-header">
    <div class="progress"><span :style="{width: progress + '%'}"></span></div>
    <div class="questionnaire-header-text">
      为方便医生了解病情，提高疗效，<br>请认真详细填写各项内容
    </div>
  </div>
</template>

<style lang="less" scoped>
  .questionnaire-header{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 21;
    .progress{
      background: #F7F7F7;
      width: 100%;
      height: 8px;
      z-index: 20;
      span{
        display: block;
        height: 100%;
        background: #395298;
        width: 20px;
      }
    }
    .questionnaire-header-text{
      padding: 8px 20px 6px;
      height: 84px;
      width: 100%;
      background: @xile;
      color: #FFF;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 15px;
      line-height: 26px;
      font-weight: bold;
    }
  }


</style>

<script type="text/javascript">
  export default {
    props: {
      width: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        progress: 0,
      }
    },
    mounted() {
      // 设置顶部滚动进度条
      let viewHeight = $(window).height();
      let scrollHeight = $("body")[0].scrollHeight;
      let currentHeight = scrollHeight - viewHeight;
      $(window).on('scroll', () => {
        let currentViewHeight = $(window).height();
        let currentBodyHeight = $("body")[0].scrollHeight;
        let currentScroll = $(window).scrollTop();
        this.progress = Math.ceil(100 - (currentBodyHeight - currentViewHeight - currentScroll) / currentHeight * 100);
      })
    },
    beforeDestory() {
      $(window).off('scroll')
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/pageScrollProgress.vue